module.exports = __webpack_public_path__ + "static/media/black-trainersflats.c9b156c7.jpg";